export default {
  saveSuccess: '儲存成功',
  saveFailed: '儲存失敗',
  deleteSuccess: '刪除成功',
  deleteFailed: '刪除失敗',
  updateSuccess: '更新成功',
  updateFailed: '更新失敗',
  networkError: '網路錯誤，請稍後重試',
  serverError: '伺服器錯誤，請稍後重試',
  timeout: '請求逾時，請稍後重試',
  actionSuccess: '操作成功',
  actionFailed: '操作失敗',
  addSuccess: '新增成功',
  editSuccess: '編輯成功',
  deleteSuccess: '刪除成功',
  saveSuccess: '儲存成功',
  saveFailed: '儲存失敗',
  confirmDelete: '確定要刪除嗎？此操作不可恢復',
  product: {
    addSuccess: '產品新增成功',
    editSuccess: '產品編輯成功',
    deleteSuccess: '產品刪除成功',
  },
  batch: {
    saveSuccess: '儲存成功',
    saveFailed: '儲存失敗',
    deleteSuccess: '刪除成功',
    deleteFailed: '刪除失敗',
  },
  category: {
    actionSuccess: '操作成功',
    actionFailed: '操作失敗',
    deleteSuccess: '刪除成功',
  },
  attr: {
    actionSuccess: '操作成功',
    actionFailed: '操作失敗',
    deleteSuccess: '刪除成功',
  },
  gift: {
    actionSuccess: '操作成功',
    actionFailed: '操作失敗',
    deleteSuccess: '刪除成功',
  },
  giftCategory: {
    actionSuccess: '操作成功',
    actionFailed: '操作失敗',
    deleteSuccess: '刪除成功',
  },
  factory: {
    actionSuccess: '操作成功',
    actionFailed: '操作失敗',
    deleteSuccess: '刪除成功',
    deleteFailed: '刪除失敗',
  },
};
